import { UsersTable } from './components/UsersTable'
import { UsersTableProvider } from './UsersTableContext'

const Users: React.FC = () => (
  <UsersTableProvider>
    <UsersTable />
  </UsersTableProvider>
)

export default Users
